var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerbia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0V5.33h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24 10.67H0v5.333h24V10.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.068 4.52v3.99c0 2.25 3 3 3 3s2.962-.697 2.962-3V4.52H6.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M7.298 5.218h3.48V3.83l-.698.345-1.042-1.042-1.043 1.042-.697-.345v1.388zm4.005 3.847L9.044 6.808 6.78 9.065l.743.743 1.522-1.523 1.523 1.523.735-.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.303 6.957h-1.05a.705.705 0 00.09-.352.69.69 0 00-1.306-.323.705.705 0 00-.615-.367.698.698 0 00-.697.69.75.75 0 00.098.352H6.75a.75.75 0 00.75.698.697.697 0 00.697.69.69.69 0 00.57.682L8.19 10.25a2.174 2.174 0 001.703 0l-.548-1.238a.69.69 0 00.57-.682.698.698 0 00.698-.69.75.75 0 00.69-.683z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerbia);
export default __webpack_public_path__ + "static/media/Serbia.0b1b5e277325ee61b7bb98571f2d7dbf.svg";
export { ForwardRef as ReactComponent };